import { z } from "zod";

export const loginSchema = z.object({
  nome: z.string().nonempty("O nome é obrigatório"),
  senha: z.string()
    .min(5, "A senha deve ter pelo menos 5 caracteres")
});
